import * as BABYLON from "@babylonjs/core/Legacy/legacy";
import { GameScene } from "../scene.js";

import { BasicPathMeshPool, BasicPathType } from "./basic.js";
import { BreakDownPathMeshPool, BreakUpPathMeshPool } from "./break.js";
import { CoinMeshPool } from "./coin.js";
import { IMeshPool, PathMeshType } from "./common.js";
import { Fire, FirePool } from "./fire.js";
import { CollideEndBoxPool } from "./collideBox";

export class MeshPool {
	basicStraightPathPool: BasicPathMeshPool;
	basicLeftPathPool: BasicPathMeshPool;
	basicRightPathPool: BasicPathMeshPool;

	breakDownPathPool: BreakDownPathMeshPool;
	breakUpPathPool: BreakUpPathMeshPool;
	coinPool: CoinMeshPool;
	firePool: FirePool;
	collideEndBoxPool: CollideEndBoxPool;

	constructor(scene: GameScene) {
		this.basicStraightPathPool = new BasicPathMeshPool(
			scene,
			BasicPathType.straight,
		);
		this.basicLeftPathPool = new BasicPathMeshPool(
			scene,
			BasicPathType.turnLeft,
		);
		this.basicRightPathPool = new BasicPathMeshPool(
			scene,
			BasicPathType.turnRight,
		);

		this.coinPool = new CoinMeshPool(scene);
		this.breakDownPathPool = new BreakDownPathMeshPool(scene);
		this.breakUpPathPool = new BreakUpPathMeshPool(scene);
		this.firePool = new FirePool(scene);
		this.collideEndBoxPool = new CollideEndBoxPool(scene);
	}

	loadAssets(engine: BABYLON.Engine) {
		this.firePool.loadAssets(engine);
	}

	getMeshPool(type: PathMeshType): IMeshPool {
		const d = new Map<PathMeshType, IMeshPool>();
		d[PathMeshType.straight] = this.basicStraightPathPool;
		d[PathMeshType.turnLeft] = this.basicLeftPathPool;
		d[PathMeshType.turnRight] = this.basicRightPathPool;

		d[PathMeshType.breakDown] = this.breakDownPathPool;
		d[PathMeshType.breakUp] = this.breakUpPathPool;

		d[PathMeshType.coin] = this.coinPool;
		return d[type];
	}

	getFirePool(): FirePool {
		return this.firePool;
	}
}
